import { render } from "./HomeProgetti.vue?vue&type=template&id=2e62d307&ts=true"
import script from "./HomeProgetti.vue?vue&type=script&lang=ts"
export * from "./HomeProgetti.vue?vue&type=script&lang=ts"

import "./HomeProgetti.vue?vue&type=style&index=0&id=2e62d307&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__